export default __webpack_public_path__ + "static/media/q3.53b04820.svg";